module.exports = __webpack_public_path__ + "img/icon-youtube.dc195282.svg";